import { z } from 'zod';

export const createUserSchema = z.object({
  email: z.string().email('Unesite validnu email adresu'),
  password: z.string().min(6, 'Minimum 6 karaktera'),
  firstName: z.string().min(1, 'Ime je obavezno'),
  lastName: z.string().min(1, 'Prezime je obavezno'),
  phone: z.string().optional(),
  systemRole: z.enum(['SYSTEM_ADMIN', 'TENANT_ADMIN', 'USER'], { message: 'Izaberite ulogu' }),
  emailNotifications: z.boolean().optional(),
});

export type CreateUserFormData = z.infer<typeof createUserSchema>;

export const updateUserSchema = z.object({
  email: z.string().email('Unesite validnu email adresu'),
  firstName: z.string().min(1, 'Ime je obavezno'),
  lastName: z.string().min(1, 'Prezime je obavezno'),
  phone: z.string().optional(),
  systemRole: z.enum(['SYSTEM_ADMIN', 'TENANT_ADMIN', 'USER'], { message: 'Izaberite ulogu' }),
  emailNotifications: z.boolean().optional(),
  isActive: z.boolean().optional(),
});

export type UpdateUserFormData = z.infer<typeof updateUserSchema>;

export const setPasswordSchema = z
  .object({
    password: z.string().min(6, 'Minimum 6 karaktera'),
    confirmPassword: z.string().min(6, 'Minimum 6 karaktera'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Lozinke se ne poklapaju',
    path: ['confirmPassword'],
  });

export type SetPasswordFormData = z.infer<typeof setPasswordSchema>;
